<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
          <v-spacer />
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <PetsForm
            :open="dialog"
            :type="type"
            :initial-values="initialValues"
            @close="dialog = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'
import PetsForm from './PetsForm'

export default {
  name: 'PetDialog',
  components: {
    PetsForm,
  },
  props: {
    value: Boolean,
    type: {
      type: String,
      default: 'new',
    },
    petData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
        species: null,
        race: null,
        sex: null,
        birthDate: null,
        weight: '',
        microchip: '',
        passport: '',
        sterilized: false,
      },
    }
  },
  computed: {
    initialValues() {
      if (this.type === 'new') return this.form
      const initialValues = cloneDeep(this.petData)
      initialValues.birthDate = moment(this.petData.birthDate).format('YYYY-MM-DD')
      initialValues.species = this.petData.species.id
      initialValues.race = this.petData.race.id
      return initialValues
    },
    title() {
      return this.type === 'new' ? this.$t('pets.form.newPet') : this.$t('pets.form.editPet')
    },
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style>

</style>
